import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Checkbox,
  FormControlLabel,
  Snackbar,
  Alert,
  Grid,
  Typography,
  Button,
} from "@mui/material";
// import useCourseCatalog from "../hooks/CourseCatalogHook"; // Replace with useFirestore
import useFirestore from "../../../../config/fireBaseHook"; // Import the useFirestore hook
import { TpCreditTypeDropdown } from "../DropDowns";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const Edit = ({ open, onClose, course, onRecordUpdated }) => {
  const { updateData } = useFirestore("TpCourseCatalog"); // Use useFirestore for the collection
  const [formData, setFormData] = useState(course || {});
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [confirmCloseOpen, setConfirmCloseOpen] = useState(false);

  useEffect(() => {
    setFormData(course || {});
  }, [course]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked ? -1 : 0,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      // The useFirestore updateData hook expects (docId, dataToUpdate)
      // Assuming formData.id contains the document ID
      const { id, ...dataToUpdate } = formData;
      if (!id) throw new Error("Document ID is missing.");
      await updateData(id, dataToUpdate);
      setLoading(false);
      setSnackbarMessage("Record has been updated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      if (onRecordUpdated) onRecordUpdated();
    } catch (error) {
      console.error("Error updating record:", error);
      setLoading(false);
      setSnackbarMessage(`Error updating record: ${error.message}`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  // The X (and backdrop/Escape, which share the same Dialog onClose) always
  // asks for confirmation first rather than closing immediately, so an
  // in-progress edit isn't lost by an accidental click.
  const handleCloseAttempt = () => {
    setConfirmCloseOpen(true);
  };

  const handleCancelClose = () => {
    setConfirmCloseOpen(false);
  };

  const handleConfirmClose = () => {
    setConfirmCloseOpen(false);
    onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleCloseAttempt} maxWidth="md" fullWidth>
        <ModalDialogTitle onClose={handleCloseAttempt}>
          Edit Record
        </ModalDialogTitle>
        <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Course"
              name="Course"
              value={formData?.Course || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Subject"
              name="Subject"
              value={formData?.Subject || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TpCreditTypeDropdown
              value={formData?.Credit_Type || ""}
              onChange={handleChange}
              name="Credit_Type"
              label="Credit Type"
              fullWidth
              margin="normal"
            />
            <TextField
              label="Credits"
              name="Credits"
              value={formData?.Credits || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Ode Course"
              name="Ode_Course"
              value={formData?.Ode_Course || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Ode Subject Code"
              name="Ode_Subject_Code"
              value={formData?.Ode_Subject_Code || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="TP Pathway"
              name="TP_Pathway"
              value={formData?.TP_Pathway || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Ode Program"
              name="Ode_Program"
              value={formData?.Ode_Program || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Ode Program Code"
              name="Ode_Program_Code"
              value={formData?.Ode_Program_Code || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="TP Pthwy abv"
              name="TP_Pthwy_abv"
              value={formData?.TP_Pthwy_abv || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="School Year Active"
              name="School_Year_Active"
              value={formData?.School_Year_Active || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Course And Subject"
              name="Course_And_Subject"
              value={formData?.Course_And_Subject || ""}
              fullWidth
              margin="normal"
              InputProps={{
                readOnly: true,
                style: { color: "#888", backgroundColor: "#f5f5f5" },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Internal Note"
              name="Internal_Note"
              value={formData?.Internal_Note || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="External Note"
              name="External_Note"
              value={formData?.External_Note || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Pilot Note"
              name="Pilot_Note"
              value={formData?.Pilot_Note || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Credit Capture Scheme"
              name="credit_capture_scheme"
              value={formData?.credit_capture_scheme || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.Lab_Type_Course === -1}
                  onChange={handleCheckboxChange}
                  name="Lab_Type_Course"
                />
              }
              label="Lab Type Course"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.Shell_Option === -1}
                  onChange={handleCheckboxChange}
                  name="Shell_Option"
                />
              }
              label="Shell Option"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.Pilot === -1}
                  onChange={handleCheckboxChange}
                  name="Pilot"
                />
              }
              label="Pilot"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.New === -1}
                  onChange={handleCheckboxChange}
                  name="New"
                />
              }
              label="New"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <ModalActions onSave={handleSubmit} saving={loading} />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      </Dialog>
      <Dialog
        open={confirmCloseOpen}
        onClose={handleCancelClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent sx={{ pt: 3 }}>
          <Typography>
            Are you sure you want to close before saving your changes?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCancelClose}>No</Button>
          <Button onClick={handleConfirmClose} variant="contained" color="error">
            Yes, Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Edit;
